import { MbExpandableText, MbProgressBar } from '@am/moebius';
import { SearchBoxComponent } from '@am/search-box';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { BackgroundImageDirective, DeferLoadDirective } from '@shared/directives';
import { CurrencyPipe } from '@shared/pipes';
import { AlertContentComponent } from '../commons/alert-content/alert-content.component';
import { HeaderLandingComponent } from '../commons/header-landing/header-landing.component';
import { SearchWidgetComponent } from '../commons/search-widget/search-widget.component';
import { SearchBoxModalComponent } from '../commons/searchbox-modal/searchbox-modal.component';
import { SearchBoxSummaryComponent } from '../commons/searchbox-summary/searchbox-summary.component';
import { SearchBoxSkeletonComponent } from '../commons/searchbox-skeleton/searchbox-skeleton.component';

import { CheckPipe } from '@shared/pipes';
import { PaymentMethodModalComponent } from 'app/commons/payment-method-modal/payment-method-modal.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import {
  AppliedFiltersListComponent,
  BannerNowTwelveComponent,
  BenefitsBannerComponent,
  CardFilterComponent,
  CheckboxListComponent,
  ErrorNoResultsComponent,
  FewOfferAcceleratorComponent,
  FewOfferComponent,
  FiltersListComponent,
  FiltersListSkeletonComponent,
  HotelComponent,
  HotelPriceComponent,
  HotelsListComponent,
  HotelsListSkeletonComponent,
  InterlinkingComponent,
  OutstandingPromoComponent,
  PaginatorComponent,
  PriceByComponent,
  PricingExpandableComponent,
  PricingPopoverComponent,
  RecommendedHotelsComponent,
  SeoSearchComponent,
  SortingByComponent,
  SortingByMobileComponent,
  UserInactivityComponent,
  ViewMapComponent,
} from './../components';

import { BannerDollarTransferComponent } from './../components/banner-dollar-transfer/banner-dollar-transfer.component';
import { BannerBenefitDisneyComponent } from './../components/banner-benefit-disney/banner-benefit-disney.component';
import { BannerDollarComponent } from './../components/banner-dollar/banner-dollar.component';
import { HotelsMapInfoWindowComponent } from './../components/hotels-map/hotels-map-info-window/hotels-map-info-window.component';
import { HotelsMapComponent } from './../components/hotels-map/hotels-map.component';
import { hotelsIcons } from '@icons/index';
import { AmExpertsCompensationComponent } from '@am/experts-compensation';
import { AmExpertsModalErrorComponent } from '@am/experts-modal-error';
import { AmExpertsShareComponent } from '@am/experts-share';
import { AmTripsAddProductModule } from '@am/trips-add-product';

import {
  MbAccelerator,
  MbAcceleratorDescription,
  MbAcceleratorTitle,
  MbAdvice,
  MbAlert,
  MbBadge,
  MbBreadcrumbs,
  MbButton,
  MbCard,
  MbCarousel,
  MbCarouselItem,
  MbCheckbox,
  MbChips,
  MbChip,
  MbBasicDialog,
  MbDialogBody,
  MbDialogFooter,
  MbDialogHeader,
  MbExpandablePanel,
  MbFormField,
  MbIcon,
  MbIconRegistry,
  MbIconText,
  MbPaginator,
  MbPopoverContent,
  MbPopoverTrigger,
  MbRadioGroup,
  MbRadioButton,
  MbRecommendedCard,
  MbReviewsDetail,
  MbReviewsEvaluation,
  MbReviewsRating,
  MbSliderRange,
  MbStarsRating,
  MbSwitch,
  MbTooltipContent,
  MbTooltipTrigger,
} from '@am/moebius';
import { FiltersMenuComponent } from 'app/components/filters-menu/filters-menu.component';

const COMPONENTS = [
  HotelsListComponent,
  HotelsListSkeletonComponent,
  HotelComponent,
  FiltersListComponent,
  CheckboxListComponent,
  CardFilterComponent,
  FiltersListSkeletonComponent,
  AppliedFiltersListComponent,
  OutstandingPromoComponent,
  PaginatorComponent,
  HotelPriceComponent,
  ErrorNoResultsComponent,
  PriceByComponent,
  SortingByComponent,
  UserInactivityComponent,
  SortingByMobileComponent,
  BenefitsBannerComponent,
  ViewMapComponent,
  BannerNowTwelveComponent,
  ViewMapComponent,
  FewOfferComponent,
  FewOfferAcceleratorComponent,
  RecommendedHotelsComponent,
  SeoSearchComponent,
  InterlinkingComponent,
  PricingExpandableComponent,
  PricingPopoverComponent,
  HotelsMapComponent,
  HotelsMapInfoWindowComponent,
  BannerDollarComponent,
  BannerBenefitDisneyComponent,
  BannerDollarTransferComponent,
  FiltersMenuComponent,
];

const MOEBIUSCOMPONENTS = [
  MbAccelerator,
  MbAcceleratorDescription,
  MbAcceleratorTitle,
  MbAdvice,
  MbAlert,
  MbBadge,
  MbBreadcrumbs,
  MbButton,
  MbCard,
  MbCarousel,
  MbCarouselItem,
  MbCheckbox,
  MbChips,
  MbChip,
  MbBasicDialog,
  MbDialogBody,
  MbDialogFooter,
  MbDialogHeader,
  MbExpandablePanel,
  MbFormField,
  MbIcon,
  MbIconText,
  MbPaginator,
  MbPopoverContent,
  MbPopoverTrigger,
  MbRadioGroup,
  MbRadioButton,
  MbRecommendedCard,
  MbReviewsDetail,
  MbReviewsEvaluation,
  MbReviewsRating,
  MbSliderRange,
  MbStarsRating,
  MbSwitch,
  MbTooltipContent,
  MbTooltipTrigger,
];

const EXPERTSCOMPONENTS = [
  AmExpertsShareComponent,
  AmExpertsCompensationComponent,
  AmExpertsModalErrorComponent,
  AmTripsAddProductModule,
];

@NgModule({
  exports: [
    ReactiveFormsModule,
    MbAlert,
    MbProgressBar,
    DeferLoadDirective,
    CurrencyPipe,
    CheckPipe,
    AlertContentComponent,
    SearchBoxSummaryComponent,
    SearchBoxModalComponent,
    SearchBoxSkeletonComponent,
    HeaderLandingComponent,
    SearchWidgetComponent,
    GoogleMapsModule,
    MbExpandableText,
    BackgroundImageDirective,
    PaymentMethodModalComponent,
    ...COMPONENTS,
    ...MOEBIUSCOMPONENTS,
    ...EXPERTSCOMPONENTS,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MbAlert,
    MbIconText,
    MbIcon,
    MbBasicDialog,
    MbProgressBar,
    SearchBoxComponent,
    MbExpandableText,
    GoogleMapsModule,
    ...MOEBIUSCOMPONENTS,
    ...EXPERTSCOMPONENTS,
    CurrencyPipe,
    DeferLoadDirective,
    CheckPipe,
    AlertContentComponent,
    SearchBoxSummaryComponent,
    SearchBoxModalComponent,
    SearchBoxSkeletonComponent,
    HeaderLandingComponent,
    SearchWidgetComponent,
    BackgroundImageDirective,
    PaymentMethodModalComponent,
    ...COMPONENTS,
  ],
  providers: [{ provide: 'BASE_URL_NTPM', useValue: '' }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
  constructor(private mbIconRegistry: MbIconRegistry) {
    for (const icon of hotelsIcons) {
      this.mbIconRegistry.addSvgIconDefinition(icon);
    }
  }
}
